import React from 'react';
import { Button } from './Button';

export function ConfirmDialog({
  open,
  title = 'Please confirm',
  message = '',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
  variant = 'danger',
  /** When true, shows a single acknowledgement button (no destructive confirm). */
  alertOnly = false,
}) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl shadow-large border border-slate-200/80 w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-5 border-b border-slate-100 bg-gradient-to-r from-slate-50/90 to-white">
          <h3 className="text-lg font-semibold text-slate-900 tracking-tight">{title}</h3>
          {message && <p className="text-sm text-slate-600 mt-2 leading-relaxed">{message}</p>}
        </div>
        <div className="px-6 py-4 bg-slate-50/50 border-t border-slate-100 flex items-center justify-end gap-3">
          {!alertOnly ? (
            <Button type="button" variant="secondary" onClick={onCancel} disabled={loading}>
              {cancelText}
            </Button>
          ) : null}
          <Button
            type="button"
            variant={alertOnly ? 'primary' : variant}
            onClick={alertOnly ? onCancel : onConfirm}
            loading={loading}
            disabled={loading}
          >
            {alertOnly ? (confirmText || 'OK') : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
